import { isStringWithValue } from '@/utils/helpers/isStringWithValue';
import { ISbLink } from '@/utils/interfaces/common';
import { IFeatureTabNoContent } from '@/utils/interfaces/components';
import { Tab } from '@headlessui/react';
import Link from 'next/link';
import { Fragment, useState } from 'react';
import { BrandIcon } from './Icons/BrandIcon';
import { Icon } from './Icon';
import { Arrow } from './Icons/Arrow';
import { SbImageWrapper } from './Image/SbImageWrapper';
import { SbImage } from './Image/SbImage';
import { FormattedText } from './FormattedText';
import { CTA } from './CTA/CallToAction';
import { useRouter } from 'next/router';
interface IProps {
  tabs: IFeatureTabNoContent[];
  cta: ISbLink;
  ctaLabel: string;
  preview: boolean;
}

type MapKindToComponentT = {
  [key: string]: string;
};

const lengthMap: MapKindToComponentT = {
  '1': 'w-1/2',
  '2': 'w-1/3',
  '3': 'w-1/4',
  '4': 'w-1/5',
  '5': 'w-1/6',
};

export const FeatureTabsDesktopNoContent: React.FC<IProps> = ({
  tabs,
  cta,
  ctaLabel,
}) => {
  const length: string = tabs.length.toString();
  const width = lengthMap[length];

  const tabClassNames = [
    'flex',
    'flex-col',
    'items-center',
    'justify-center',
    'w-full',
    'bg-gray-light',
    'px-3',
    'py-4',
    'transition-colors',
    'duration-200',
    `${width}`,
  ];

  const flexControlClasses = [
    'relative',
    'flex',
    'w-full',
    'lg:flex-row',
    'justify-between',
    'md:flex-col',
  ];
  const textContainerClasses = [
    'justify-center',
    'text-left',
    'flex',
    'flex-col',
    'flex-1',
    'max-w-[494px]',
    'lg:py-[92px]',
  ];
  const imageContainerClasses = [
    'md:flex',
    'md:flex-col',
    'lg:min-h-[500px]',
    'lg:min-w-[560px]',
    'md:justify-center',
    'xl:min-h-[600px]',
    'xl:min-w-[660px]',
  ];
  let href = '/';
  const { locale } = useRouter();
  const [urlLocale, setUrlLocale] = useState<string | undefined>(locale);



  return (
    <div className="">
      <Tab.Group>
        <Tab.List>
          <div className="flex w-full space-x-[2px]">
            {tabs.map((tab, key) => {
              const cached_url = tab.home_link?.cached_url || '';
              const pathSegments = cached_url.split('/');
              const linkLocale = pathSegments[0];
              const isLocale = /^en-[a-z]{2}$/.test(linkLocale);

              const validLocale = isLocale ? linkLocale : locale;
              const cleanedUrl = isLocale ? pathSegments.slice(1).join('/') : cached_url;

              return (
                <Tab as={Fragment} key={key}>
                  {({ selected }) => (
                    <Link href={`/${cleanedUrl}`} locale={validLocale} passHref>
                      <button
                        className={`${tabClassNames.join(' ')} ${selected
                          ? 'bg-green-dark text-white'
                          : 'bg-gray-light text-green-dark'
                          } `}
                      >
                        <div>
                          <div className="flex justify-center">
                            <span className="w-10 h-10">
                              <BrandIcon dark={selected} label={tab.icon} />
                            </span>
                          </div>
                          <span className="block mt-2 break-all text-sm font-medium leading-6 text-inherit">
                            {tab.label}
                          </span>
                        </div>
                      </button>
                    </Link>
                  )}
                </Tab>
              );
            })}
           
          </div>
        </Tab.List>
      </Tab.Group>
    </div>
  );
};
